import {
  AgentMessageEventToolCallMetadataInput,
  ELMA365DescribeImageToolCallDataToolTypeEnum,
  ELMA365GeneralToolCallDataInput,
  FileReadFileToolDataToolTypeEnum,
  ToolsetSettingsType,
} from '../../../../gamma-api';

export const showRenderModeSwitcher = (toolCallMetadata: AgentMessageEventToolCallMetadataInput): boolean => {
  switch (toolCallMetadata.toolset_settings_type) {
    case ToolsetSettingsType.DateTime:
    case ToolsetSettingsType.McpServer:
      return false;
    case ToolsetSettingsType.Elma365General: {
      const toolType = (toolCallMetadata.data as ELMA365GeneralToolCallDataInput).tool_data.tool_type;
      return (
        toolType === FileReadFileToolDataToolTypeEnum.ReadFile ||
        toolType === ELMA365DescribeImageToolCallDataToolTypeEnum.DescribeImage
      );
    }
    case ToolsetSettingsType.Elma365Toolkit:
      return false;
    default:
      return true;
  }
};
